import React from "react";
import Icons from "./Icons";
import { FaPauseCircle, FaPlayCircle } from "react-icons/fa";

export const SideBarpennel = ({
  setShowAddPanel,
  showAddPanel,
  profileStatus, 
  handlePauseClick, 
}) => {
  return (
    <div
      className={`flex-shrink-0 flex flex-col 
        h-[calc(100vh-35px)]
        bg-mylightbg dark:bg-[#0D1117]
        shadow-lg transition-all duration-500 overflow-hidden
        ${showAddPanel ? "w-[110px]" : "w-[50px]"}
        border-r-[1px] border-gray-500`}
      // border-r-2 border-blue-500
    >
      {/* 🔹 TOP ICONS */}
      <nav className="">
        {/* 🔥😎😎 TRADING ON/OFF BUTTON */}
        <button
          onClick={handlePauseClick}
          className={`flex items-center w-full 
    ${showAddPanel ? "justify-start px-2" : "justify-center"} 
    py-2  text-xs font-semibold 
    transition-all duration-200 hover:scale-[1.05] gap-2
    ${
      !profileStatus.trading_status
        ? "bg-green-200 text-green-800"
        : "bg-red-200 text-red-800"
    }`}
        >
          {!profileStatus.trading_status ? (
            <>
              <FaPauseCircle size={16} />
              {showAddPanel && <span>Trading ON</span>}
            </> 
          ) : (
            <>
              <FaPlayCircle size={16} />
              {showAddPanel && <span>Trading OFF</span>}
            </>
          )}
        </button>
        <Icons name="TradeNow" showAddPanel={showAddPanel} />
        <Icons name="Order" showAddPanel={showAddPanel} />
        <Icons name="Position" showAddPanel={showAddPanel} />
        <Icons name="Alert" showAddPanel={showAddPanel} />
        <hr />
        <Icons name="Note" showAddPanel={showAddPanel} />
      </nav>

      {/* 🔹 BOTTOM ICON */}
      {/* <div className="">
        <Icons name="Note" showAddPanel={showAddPanel} />
      </div> */}
    </div>
  );
};





// //   bg-mylightbg dark:bg-[#1F2937 ]





// import React from "react";
// import Icons from "./Icons";
// import { FaPauseCircle, FaPlayCircle } from "react-icons/fa";

// export const SideBarpennel = ({
//   setShowAddPanel,
//   showAddPanel,
//   profileStatus, 
//   handlePauseClick, 
//   darkMode = false,
// }) => {
//   // Colors based on darkMode
//   const colors = {
//     bgSidebar: darkMode ? '#0D1117' : '#ffffff',
//     borderColor: darkMode ? '#30363D' : '#e5e7eb',
//     textPrimary: darkMode ? '#F0F4F8' : '#111827',
//     textSecondary: darkMode ? '#D1D5DB' : '#374151',
//     buttonOnBg: darkMode ? 'rgba(34, 197, 94, 0.2)' : '#dcfce7',
//     buttonOnText: darkMode ? '#4ade80' : '#166534',
//     buttonOffBg: darkMode ? 'rgba(239, 68, 68, 0.2)' : '#fee2e2',
//     buttonOffText: darkMode ? '#f87171' : '#991b1b',
//   };

//   return (
//     <div
//       style={{
//         flexShrink: 0,
//         display: 'flex',
//         flexDirection: 'column',
//         height: 'calc(100vh - 35px)',
//         backgroundColor: colors.bgSidebar,
//         boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
//         transition: 'all 0.5s ease',
//         overflow: 'hidden',
//         width: showAddPanel ? '110px' : '50px',
//         borderRight: `1px solid ${colors.borderColor}`
//       }}
//     >
//       {/* TOP ICONS */}
//       <nav>
//         {/* TRADING ON/OFF BUTTON */}
//         <button
//           onClick={handlePauseClick}
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             width: '100%',
//             justifyContent: showAddPanel ? 'flex-start' : 'center',
//             padding: '0.5rem',
//             fontSize: '0.75rem',
//             fontWeight: 600,
//             transition: 'all 0.2s ease',
//             gap: '0.5rem',
//             backgroundColor: !profileStatus.trading_status ? colors.buttonOnBg : colors.buttonOffBg,
//             color: !profileStatus.trading_status ? colors.buttonOnText : colors.buttonOffText,
//             border: 'none',
//             cursor: 'pointer'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
//           onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//         >
//           {!profileStatus.trading_status ? (
//             <>
//               <FaPauseCircle size={16} />
//               {showAddPanel && <span>Trading ON</span>}
//             </>
//           ) : (
//             <>
//               <FaPlayCircle size={16} />
//               {showAddPanel && <span>Trading OFF</span>}
//             </>
//           )}
//         </button>
        
//         <Icons name="TradeNow" showAddPanel={showAddPanel} darkMode={darkMode} />
//         <Icons name="Order" showAddPanel={showAddPanel} darkMode={darkMode} />
//         <Icons name="Position" showAddPanel={showAddPanel} darkMode={darkMode} />
//         <Icons name="Alert" showAddPanel={showAddPanel} darkMode={darkMode} />
        
//         <hr style={{
//           margin: '0.5rem 0',
//           borderColor: colors.borderColor
//         }} />
        
//         <Icons name="Note" showAddPanel={showAddPanel} darkMode={darkMode} />
//       </nav>
//     </div>
//   );
// };